/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Highlight_Next_EventInputs */

const en_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlight Next Event`)
};

const fr_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'evenement suivant a la selection`)
};

const de_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Event hervorheben`)
};

const it_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidenzia il prossimo evento`)
};

const ru_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выделите следующее событие`)
};

const es_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacar el próximo evento`)
};

const zh_cn2_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个活动亮点`)
};

const ja_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントをハイライト`)
};

const hi_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले कार्यक्रम को हाइलाइट करें`)
};

const pt_pt2_shortcut_keys_name_highlight_next_event = /** @type {(inputs: Shortcut_Keys_Name_Highlight_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaque o próximo evento`)
};

/**
* | output |
* | --- |
* | "Highlight Next Event" |
*
* @param {Shortcut_Keys_Name_Highlight_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_highlight_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Highlight_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Highlight_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_highlight_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_highlight_next_event(inputs)
	return en_shortcut_keys_name_highlight_next_event(inputs)
});